import React from "react";



const PlanningStage = (props) => {
    return (
<div class="table-responsive">
<table class="table">
  <thead>
    <tr>
      <th scope="col"></th>
      <th scope="col" className="planning-title">Lundi</th>
      <th scope="col" className="planning-title">Mardi</th>
      <th scope="col" className="planning-title">Mercredi</th>
      <th scope="col" className="planning-title">Jeudi</th>
      <th scope="col" className="planning-title">Vendredi</th>

    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row" className="planning-title">9h - 9h15</th>
      <td className="planning-rowlight">Accueil</td>
      <td className="planning-rowlight">Accueil</td>
      <td className="planning-rowlight">Accueil</td>
      <td className="planning-rowlight">Accueil</td>
      <td className="planning-rowlight">Accueil</td>

    </tr>
    <tr>
      <th scope="row" className="planning-title">9h15 - 12h</th>
      <td className="planning-rowdark">Technique, relais et lancer</td>
      <td className="planning-rowdark">Demi-fond, perche</td>
      <td className="planning-rowdark">Circuit ludique pour les sauts</td>
      <td className="planning-rowdark">Hauteur, marche athlétique</td>
      <td className="planning-rowdark">Kid-cross</td>

    </tr>
    <tr>
      <th scope="row" className="planning-title">12h - 14h</th>
      <td className="planning-rowlight">Repas, temps libre</td>
      <td className="planning-rowlight">Repas, temps libre</td>
      <td className="planning-rowlight">Repas, temps libre</td>
      <td className="planning-rowlight">Repas, temps libre</td>
      <td className="planning-rowlight">Repas, temps libre</td>
    </tr>
    <tr>
      <th scope="row" className="planning-title">14h - 16h</th>
      <td className="planning-rowdark">Relai, haies</td>
      <td className="planning-rowdark">Rugby flag</td>
      <td className="planning-rowdark">Parcours d'obstacles</td>
      <td className="planning-rowdark">Kindball</td>
      <td className="planning-rowdark">Football</td>
    </tr>
    <tr>
      <th scope="row" className="planning-title">16h - 17h</th>
      <td className="planning-rowlight">Goûter, temps libre</td>
      <td className="planning-rowlight">Goûter, temps libre</td>
      <td className="planning-rowlight">Goûter, temps libre</td>
      <td className="planning-rowlight">Goûter, temps libre</td>
      <td className="planning-rowlight">Goûter, temps libre</td>
    </tr>
  </tbody>
</table>
</div>
  );
};
export default PlanningStage; 